import { Navigate, useLocation } from 'react-router-dom';
import {
    getAuthCallbackError,
    hasEmailConfirmationCallback,
    hasRecoveryCallbackParams,
} from '../utils/recoverySession';

export function RootRedirect() {
    const location = useLocation();
    const suffix = `${location.search}${location.hash}`;

    if (hasRecoveryCallbackParams()) {
        return <Navigate to={`/reset-password${suffix}`} replace />;
    }

    if (hasEmailConfirmationCallback() || getAuthCallbackError()) {
        return <Navigate to={`/login${suffix}`} replace />;
    }

    return <Navigate to="/login" replace />;
}
